import { useEffect, useState } from "react";

const ligneVide = () => ({ prenom: "", nom: "", email: "", fonction: "", role: "commercial" });
const input = { display: "block", width: "100%", padding: 8, marginTop: 4, boxSizing: "border-box" };

function QuestionnaireDemandeUtilisateurs({ clientSupabase, token }) {
  const [contexte, setContexte] = useState(null);
  const [lignes, setLignes] = useState([ligneVide()]);
  const [message, setMessage] = useState("Chargement...");
  const [envoi, setEnvoi] = useState(false);

  useEffect(() => {
    let actif = true;
    clientSupabase.rpc("demande_utilisateurs_publique_lire", { p_token: token }).then(({ data, error }) => {
      if (!actif) return;
      const demande = data?.[0];
      if (error || !demande) { setMessage("Ce lien est invalide ou a expiré."); return; }
      setContexte(demande);
      setMessage(demande.statut === "EN_ATTENTE" ? "" : "Cette demande a déjà été transmise ou clôturée.");
    });
    return () => { actif = false; };
  }, [clientSupabase, token]);

  const modifier = (index, nom, valeur) => setLignes((anciennes) => anciennes.map((ligne, i) => i === index ? { ...ligne, [nom]: valeur } : ligne));
  const ajouter = () => { if (lignes.length < 20) setLignes([...lignes, ligneVide()]); };
  const retirer = (index) => { if (lignes.length > 1) setLignes(lignes.filter((_, i) => i !== index)); };
  const soumettre = async (event) => {
    event.preventDefault(); setEnvoi(true); setMessage("");
    const { error } = await clientSupabase.rpc("demande_utilisateurs_publique_soumettre", {
      p_token: token, p_utilisateurs: lignes
    });
    setEnvoi(false);
    if (error) { setMessage("Impossible d'enregistrer la demande. Vérifiez les informations ou le lien."); return; }
    setContexte((c) => ({ ...c, statut: "A_VALIDER" }));
    setMessage("La demande a bien été transmise au superviseur.");
  };

  const page = { minHeight: "100vh", background: "#f2f4f7", padding: 24, fontFamily: "Arial, sans-serif" };
  const carte = { maxWidth: 920, margin: "0 auto", background: "white", padding: 28, borderRadius: 10 };
  if (!contexte || contexte.statut !== "EN_ATTENTE") return <main style={page}><section style={carte}><h2>DEMANDE D'UTILISATEURS</h2><p>{message}</p></section></main>;

  return <main style={page}><section style={carte}>
    <h2>DEMANDE D'UTILISATEURS — {contexte.groupe_nom}</h2>
    <p>Bonjour {contexte.nom_destinataire}, ajoutez les utilisateurs souhaités. Aucun mot de passe n'est demandé.</p>
    <form onSubmit={soumettre}>
      {lignes.map((ligne, index) => <fieldset key={index} style={{ marginBottom: 16, border: "1px solid #ddd", borderRadius: 8, padding: 14 }}>
        <legend>Utilisateur {index + 1}</legend>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10 }}>
          <label>Prénom *<input required value={ligne.prenom} onChange={(e) => modifier(index, "prenom", e.target.value)} style={input}/></label>
          <label>Nom *<input required value={ligne.nom} onChange={(e) => modifier(index, "nom", e.target.value)} style={input}/></label>
          <label>Email *<input required type="email" value={ligne.email} onChange={(e) => modifier(index, "email", e.target.value)} style={input}/></label>
          <label>Fonction<input value={ligne.fonction} onChange={(e) => modifier(index, "fonction", e.target.value)} style={input}/></label>
          <label>Rôle<select value={ligne.role} onChange={(e) => modifier(index, "role", e.target.value)} style={input}><option value="commercial">Commercial</option><option value="gestionnaire">Gestionnaire</option></select></label>
        </div>
        {lignes.length > 1 && <button type="button" onClick={() => retirer(index)} style={{ marginTop: 10 }}>RETIRER</button>}
      </fieldset>)}
      <button type="button" onClick={ajouter} disabled={lignes.length >= 20} style={{ marginRight: 10 }}>+ AJOUTER UN UTILISATEUR</button>
      <button type="submit" disabled={envoi} style={{ padding: "10px 14px", background: "#1565c0", color: "white", border: 0, borderRadius: 6 }}>{envoi ? "ENVOI..." : "TRANSMETTRE LA DEMANDE"}</button>
      {message && <p style={{ color: "#b71c1c" }}>{message}</p>}
    </form>
  </section></main>;
}

export default QuestionnaireDemandeUtilisateurs;
